import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'

export const PaneEditor = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'edit_facade.application_pane_editor.title'} />
      Pane Editor
    </>
  )
}
